module.exports = __webpack_public_path__ + "static/media/login-background.5b71689d.jpg";